import { PUT_USER } from './action';

const initialState = null;

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case PUT_USER:
        return action.payload 
    default: {
      return state;
    }
  }
};

export default reducer;
